var _circle, _path, _path2, _path3, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintedBirdsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.4999,
    cy: 35.5,
    r: 30.632,
    transform: "rotate(79.9673 35.4999 35.5)",
    fill: "#80C8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9444 60.6023C24.602 65.2583 32.8364 67.0789 40.8363 65.6636C48.8362 64.2483 55.9462 59.713 60.6022 53.0555C65.2582 46.398 67.0788 38.1635 65.6635 30.1636C64.2482 22.1637 59.713 15.0537 53.0554 10.3977L35.4999 35.5L17.9444 60.6023Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9228 21.6375L17.6237 23.0064C17.3771 23.1087 17.4256 23.4716 17.6904 23.5057C18.0072 23.5464 17.9726 24.0122 17.6535 24.0252C17.3886 24.036 17.3009 24.3884 17.5329 24.5168L20.6754 26.2557C21.2238 26.5591 21.4682 27.2176 21.2508 27.8053L21.1942 27.9585C21.0761 28.2776 21.0734 28.628 21.1864 28.9489L22.5984 32.9574L24.1287 38.9099L27.4542 47.0147C27.7072 47.6313 28.6338 47.3509 28.5024 46.6974C28.4724 46.5483 28.5055 46.3934 28.5938 46.2696L44.2211 24.3517C44.5976 23.8173 44.5361 23.0897 44.0753 22.626L41.1522 19.6847C40.8356 19.3662 40.554 19.0146 40.3123 18.6361L39.4351 17.2625C38.8297 16.3144 38.0169 15.5163 37.0579 14.9283C35.8898 14.2121 34.5463 13.833 33.176 13.833L30.9841 13.833C30.447 13.833 29.911 13.8811 29.3824 13.9767C26.8353 14.4374 24.6099 15.9726 23.2748 18.1902L21.4972 21.1427C21.3635 21.3648 21.1622 21.5381 20.9228 21.6375Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.879 34.3989L19.9491 35.1997C19.8048 35.2595 19.8332 35.4718 19.9881 35.4917C20.1734 35.5155 20.1532 35.788 19.9665 35.7956C19.8116 35.802 19.7603 36.0081 19.896 36.0832L21.7343 37.1005C22.0551 37.278 22.1981 37.6631 22.0709 38.0069L22.0378 38.0965C21.9687 38.2832 21.9671 38.4882 22.0332 38.6759L22.8592 41.0209C23.448 43.3613 24.2415 45.6454 25.2307 47.8467L25.879 49.2895C25.8761 49.2803 25.8778 49.2702 25.8835 49.2624L35.5082 35.9866C35.7284 35.674 35.6924 35.2484 35.4229 34.9772L33.7129 33.2565C33.5277 33.0702 33.363 32.8645 33.2216 32.6431L32.7422 31.8924C32.3658 31.303 31.8605 30.8068 31.2644 30.4413C30.6135 30.0422 29.8738 29.8108 29.1115 29.7677L28.8199 29.7513C28.3871 29.7268 27.9529 29.7512 27.5255 29.8239L27.1432 29.8889C25.4548 30.1762 23.9755 31.1853 23.0921 32.6526L22.215 34.1094C22.1368 34.2393 22.0191 34.3407 21.879 34.3989Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.7302,
    cy: 21.0222,
    r: 1.46852,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6134,
    cy: 33.7628,
    r: 0.93075,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintedBirdsLogo);
export default __webpack_public_path__ + "static/media/painted_birds_logo.9a5a36cf.svg";
export { ForwardRef as ReactComponent };